import React from 'react';

const Header = () => {
  return (
    <div className="w-full bg-white shadow-md py-4 md:py-6 relative"> {/* Increased padding for desktop */}
      {/* Desktop Layout (Row) */}
      <div className="hidden md:flex items-center justify-between px-4 h-full">
        {/* Left Logo */}
        <img 
          src="/investain-textlogo.png" 
          alt="Company Text Logo" 
          className="h-auto w-52" 
        />

        {/* Center Logo (Absolute Centering) */}
        <div className="absolute left-1/2 transform -translate-x-1/2">
          <img 
            src="/investain_logo.png" 
            alt="Company Logo" 
            className="h-20 w-auto"
          />
        </div>

        {/* Right Spacer */}
        <div className="w-[120px]"></div>
      </div>

      {/* Mobile Layout (Column) */}
      <div className="md:hidden flex flex-col items-center px-4 space-y-4 py-4">
        {/* Main Logo (Top) */}
        <img 
          src="/investain_logo.png" 
          alt="Company Logo" 
          className="h-16 w-auto"
        />

        {/* Text Logo (Bottom) */}
        <img 
          src="/investain-textlogo.png" 
          alt="Company Text Logo" 
          className="h-auto w-40"
        />
      </div>
    </div>
  );
};

export default Header;